import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';

import './VersionBanner.scss';



export default function VersionBanner({ show, setShowVersion }) {
  return (
    <div className={`version-banner ${show && 'visible'}`}>
      <div className='close-btn' onClick={() => setShowVersion(false)}><CloseIcon /></div>
      <div className='version-text'>You are currently viewing Version 1.0 of CHaMP. Please have patience and provide us with feedback as we continue to improve this tool. Thank you!</div>
    </div>
  );
}

VersionBanner.propTypes = {
  show: PropTypes.bool.isRequired,
  setShowVersion: PropTypes.func.isRequired,
};